module.exports = __webpack_public_path__ + "img/SHSSL.png";